import z from "zod";
import AuthService from "../../../services/AuthService";
import {} from "./login";
import { User } from "../../../models";
import { IError } from "../../../core/HttpClient";
import { AxiosError } from "axios";
const auth = new AuthService();
//-- form state
export type State = {
  errors?: {
    name?: string[];
    phone?: string[];
    country?: string[];
  };
  success?: boolean;
  message?: IError | null;
  defaultValues?: {
    name: string;
    phone: string;
    country: string;
  };
  data?: { verificationId: string };
};

//-- validation schema
const FormSchema = z.object({
  name: z
    .string({
      error: "Please select a customer.",
    })
    .min(3, "User Name must be more than 2 characters"),
  phone: z
    .string({
      error: "Please enter phone.",
    })
    .min(1, { message: "Phone is required" })
    .refine(
      async (e) => {
        const exist = await checkPhoneExist(e);
        return !exist;
      },
      {
        message: "Phone exist, please try login",
        path: ["phone"],
      }
    ),
});

export async function createUser(
  fPrevState: State,
  formdata: FormData
): Promise<State> {
  const defaultValues = {
    name: formdata.get("name")?.toString() || "",
    phone: formdata.get("phone")?.toString() || "",
    country: formdata.get("country")?.toString() || "",
  };
  // Remove first character if it's "0" from phone number
  const cleanPhone = defaultValues.country.replace("+", "")+(defaultValues.phone.startsWith("0") 
    ? defaultValues.phone.substring(1) 
    : defaultValues.phone);
   
  const validate = await FormSchema.safeParseAsync({
    name: defaultValues.name,
    phone: cleanPhone,
  });

  if (!validate.success) {
    return {
      errors: validate.error.flatten().fieldErrors,
      message: {
        description: "Missing Fields. Failed to Create User.",
        code: "400",
      },
      defaultValues,
    };
  }
  const { name, phone } = validate.data;

  try {
    const response = await auth.register({
      name,
      phone: phone,
    });
    const success = response.status === 200;
    if (success)
      return {
        errors: {},
        success: true,
        message: null,
        data: response.data as { verificationId: string },
        defaultValues:{
          name: defaultValues.name,
          phone: phone,
          country: defaultValues.country,
        },
      };
    else {
      const error = response.data as IError;
      return {
        errors: {},
        message: {
          description: error.description,
          code: error.code,
        },
        defaultValues,
        success: false,
      };
    }
  } catch (ex: AxiosError | any) {
    return {
      errors: {},
      message: {
        description: ex.response.data.description,
        code: ex.response.data.code,
      },
      success: false,
      defaultValues,
    };
  }
}
async function checkPhoneExist(phone: string) {
  try {
    const response = await auth.checkPhoneExist(phone);
    return response.data.exists;
  } catch (error) {
    return false;
  }
}
